import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toast, ToastContainer } from "react-toastify";

import Box from "@mui/material/Box";
import Nav from "./nav";

import Main from "./main";
import Header from "./header";
import HomeRoutes from "../HomeRoutes";
import TwilioPhone from "../../components/twilioPhone/TwilioPhone";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { logout, setProfile } from "../../features/authSlice";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { SiGooglemeet } from "react-icons/si";
import { MdAddLink } from "react-icons/md";
import VerificationTrabajadorDialog from "../../components/dialogs/VerificationTrabajadorDialog";
import { FaBook, FaBriefcase, FaChevronDown, FaChevronRight, FaCode, FaCopy, FaDollarSign, FaEdit, FaExternalLinkAlt, FaGoogle, FaIcons, FaImage, FaKey, FaLink, FaLock, FaMeetup, FaPhone, FaPlus, FaTeamspeak, FaTimes, FaTrash, FaUpload, FaUser, FaUserAlt } from "react-icons/fa";
import { useResponsive } from "../../hooks/use-responsive";
import { Button, IconButton } from "@mui/material";
import { TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import Tooltip from "../../components/ui/ToolTip";
import Modal from "../../components/ui/Modal";
import { FaBoxArchive, FaCloudArrowUp } from "react-icons/fa6";
import LateralMenuButton from "./indexComponents/LateralMenuButton";

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {

  const user = useSelector((state) => state.auth.user);

  ////////// Accesos /////////////////

  const [accounts, setAccounts] = useState([])
  const [commercialLinks, setCommercialLinks] = useState([])
  const [showList, setShowList] = useState(false)

  const [workers, setWorkers] = useState([])

  const [fileToUpload, setFileToUpload] = useState(null)

  const [newAccessModal, setNewAccessModal] = useState(false)


  // Recursos

  const [resources, setResources] = useState([])

  const [showResources, setShowResources] = useState(false)

  const getResources = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/recursosOperativa?limit=0`)
      setResources(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  // Fin recursos

  const getWorkers = async () => { // Obtener los trabajadores
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      setWorkers(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const getKeys = async () => { // Obtener los accesos
    try {
      const response = await axios.get(`${BACKEND}/api/accesosCuentasAgencia?limit=0&depth=1`)
      if (user.area.toUpperCase() === "ADMINISTRACION") {
        setAccounts(response.data.docs)
      } else {
        const filteredKeys = response.data.docs.filter((doc) => doc.workers.some((worker) => worker.id === user.id))
        setAccounts(filteredKeys)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getCommercialLinks = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/accesosAreaComercial?limit=0`)
      setCommercialLinks(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const handlePrepareFile = (event) => { // Colocar la imagen en el estado local
    const file = event.target.files[0];
    if (file.size > 5 * 1000000) {
      window.alert("Archivo superior a 5mb");
      return;
    }
    setFileToUpload(file);
  };

  const handleImageUpload = async (file) => { // Subir la imagen
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(`${BACKEND}/api/imagenesAccesos`,
        formData,
        { headers: {"Content-Type": "multipart/form-data"} }
      );

      const mediaId = response.data.doc.id; 
      return mediaId;
    } catch (error) {
      toast.error("Error subiendo la imagen: " + error)
    }
  };

  useEffect(() => {
    getKeys();
    getWorkers()
    getResources()
    if (user.area.toUpperCase() === "ADMINISTRACION" || user.area.toUpperCase() === "COMERCIAL" || user.puesto.toUpperCase() === "JEFE DE MARKETING") {
      getCommercialLinks()
    }
  }, []);

  const handleCopy = (text) => { // Copiar la row al portapapeles
    navigator.clipboard.writeText(text);
    toast.info("Copiado al portapapeles!");
  };

  const [accessFormValues, setAccessFormValues] = useState({
    title: "",
    image: "",
    accessLink: "",
    userOrEmail: "",
    password: "",
    workers: [],
  })

  const handleCheckboxChange = (workerId) => { // Cambia el estado de las checkboxes, actualiza el array de trabajadores con acceso al registro
    setAccessFormValues((prevState) => {
      const updatedWorkers = prevState.workers.includes(workerId)
        ? prevState.workers.filter((id) => id !== workerId)
        : [...prevState.workers, workerId];

      return {
        ...prevState,
        workers: updatedWorkers,
      };
    });
  };

  const uploadNewAccess = async () => { // Subir el nuevo acceso
    try {
      const imageId = await handleImageUpload(fileToUpload)
  
      const updatedFormValues = {
        ...accessFormValues,
        image: imageId
      };
  
      await axios.post(`${BACKEND}/api/accesosCuentasAgencia`, updatedFormValues, {
        withCredentials: true
      })
      
      setAccessFormValues({
        title: "",
        image: "",
        accessLink: "",
        userOrEmail: "",
        password: "",
        workers: [],
      })

      setFileToUpload(null)
  
      getKeys();
      toast.success("Acceso creado con éxito");
    } catch (e) {
      toast.error(e);
    } 
  }

  const handleDeleteAccess = async (id) => { // Eliminar el acceso
    try {
      const confirm = window.confirm("Seguro deseas eliminar este acceso?")
      if (confirm) {
        const responseDelete = await axios.delete(`${BACKEND}/api/accesosCuentasAgencia/${id}`)
        const imageId = responseDelete.data.image.id
        await axios.delete(`${BACKEND}/api/imagenesAccesos/${imageId}`)
        getKeys()
        toast.success("Acceso eliminado con éxito")
      }
    } catch (e) {
      toast.error("Error eliminando el acceso: " + e)
    }
  }

  // Editar accesos

  const [editModal, setEditModal] = useState(false) // Estado del modal de edición

  const [imageToEdit, setImageToEdit] = useState("") // URL de la imagen del registro seleccioando

  const [accessToEditId, setAccessToEditId] = useState("") // ID del registro seleccionado a editar

  const [editAccessFormValues, setAccessEditFormValues] = useState({ // Formulario de envio, edición
    title: "",
    image: "",
    accessLink: "",
    userOrEmail: "",
    password: "",
    workers: [],
  })

  const handleEditCheckboxChange = (workerId) => { // Actualiza los trabajadores a tener acceso 
    setAccessEditFormValues((prevState) => {
      const updatedWorkers = prevState.workers.includes(workerId)
        ? prevState.workers.filter((id) => id !== workerId)
        : [...prevState.workers, workerId];

      return {
        ...prevState,
        workers: updatedWorkers,
      };
    });
  };

  const handleSaveEditedAccess = async () => { // Guarda el nuevo registro, si hay una imagen nueva, elimina la antigua y reemplaza
    try {
      let updatedFormValues = { ...editAccessFormValues };
  
      if (fileToUpload) {
        // Eliminar la imagen anterior si existe
        if (updatedFormValues.image) {
          try {
            await axios.delete(`${BACKEND}/api/imagenesAccesos/${updatedFormValues.image}`);
          } catch (error) {
            toast.error("No se pudo eliminar la imagen anterior.");
            return;
          }
        }
  
        // Subir la nueva imagen
        try {
          const imageId = await handleImageUpload(fileToUpload);
          updatedFormValues = {
            ...updatedFormValues,
            image: imageId,
          };
        } catch (error) {
          toast.error("No se pudo subir la nueva imagen.");
          return;
        }
      }
  
      // Actualizar los datos en la API
      await axios.put(`${BACKEND}/api/accesosCuentasAgencia/${accessToEditId}`, updatedFormValues);
      getKeys()
  
      toast.success("Acceso actualizado correctamente");
    } catch (e) {
      toast.error("Error al actualizar el acceso: " + e.message);
    }
  };

  ////////// Fin Accesos /////////////////

  const [openNav, setOpenNav] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null); // eslint-disable-line no-unused-vars
  const [links, setLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const [openVerificationModal, setOpenVerificationModal] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const [buttonsDrawer, setButtonsDrawer] = useState(false);

  const [buttonsComercial, setButtonsComercial] = useState(false)
 
  const profileRedux = useSelector((state) => state.auth.profile);
  const tokenExp = localStorage.getItem("tokenExp")

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const lgUp = useResponsive('up', 'lg');

  const isTokenExpired = () => {
    const expTime = tokenExp
    if (!expTime) return true
    const currentTime = Math.floor(Date.now() / 1000)
    return parseInt(expTime) < currentTime
  }

  const fetchLinks = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/links`, {
        params: {
          limit: 1000,
        },
      });
      const data = response.data.docs;
      setLinks(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isTokenExpired()) {
      console.log("tokenexpired")
      dispatch(logout())
      navigate('/')
    }
    fetchLinks();
  }, []);

  const fetchProfileUser = async () => {
    if (user) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/trabajadores/${user.id}`
        );
        dispatch(setProfile(response.data));
        if (
          response.data?.verificacionHabilitada &&
          !response.data?.verificado
        ) {
          setOpenVerificationModal(false);
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    fetchProfileUser();
  }, []);
  // Filtra los enlaces en función de las subáreas a las que el usuario tiene acceso

  useEffect(() => {
    if (user?.subarea) {
      const filtered = links
        .map((link) => {
          const filteredElementos = link.elemento.filter((element) => {
            return (
              !element.access ||
              element.access.length === 0 ||
              element.access.some((access) => access.subarea === user.subarea)
            );
          });

          // Si quedan elementos después del filtrado, conserva el enlace
          if (filteredElementos.length > 0) {
            return {
              ...link,
              elemento: filteredElementos,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean); // Elimina los enlaces nulos

      setFilteredLinks(filtered);
    } else {
      // Si el usuario no tiene una subárea definida, muestra todos los enlaces
      setFilteredLinks([...links]);
    }
  }, [links, user]);

   const handleLogout = async () => {
    dispatch(logout());
    setRedirect(true);
  };

  const [closeTabs, setCloseTabs] = useState(false) // Cada que cambia el estado se cierran los botones de Comercial
  const [expandedCommercialIdx, setExpandedCommercialIdx] = useState(null) // Índice del botón comercial expandido

  if (redirect) {
    return <Navigate to={"/"} />;
  }

  if (user == null) {
    return <Navigate to={"/"} />;
  }


  const handleClick = () => {
    setIsClicked(!isClicked);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
  };

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
      setSelectedSubcategory(null);
    }
  };

  const closeOperativeTabs = () => { // Cierra área operativa
    setIsClicked(false)
    setSelectedCategory(null);
    setShowResources(false)
    setShowList(false)
  }

  const handleButtonDrawer = () => { // Area operativa
    setButtonsDrawer(!buttonsDrawer);
    if (buttonsDrawer) {
      closeOperativeTabs()
    }
    if (buttonsComercial) {
      setCloseTabs(!closeTabs)
      setButtonsComercial(false)
    }
  };

  const handleButtonComercial = () => { // Area comercial
    setButtonsComercial(!buttonsComercial);
    setCloseTabs(!closeTabs)
    setExpandedCommercialIdx(null)
    if (buttonsDrawer) {
      setButtonsDrawer(false)
      closeOperativeTabs()
    }
  };

  const closeCommercialPanel = () => { // Cerrar panel comercial (click afuera)
    setButtonsComercial(false)
    setExpandedCommercialIdx(null)
    setCloseTabs(!closeTabs)
  };

  return (
    <>
      <ToastContainer />

      <Modal // Modal para crear nuevos accesos
        onClose={() => {
          setNewAccessModal(false)
          setFileToUpload(null)
          setAccessFormValues({
            title: "",
            image: "",
            accessLink: "",
            userOrEmail: "",
            password: "",
            workers: [],
          })
        }}
        activeModal={newAccessModal}
        title="Nuevo acceso"
        centered
      >
        <form 
          className="flex flex-col gap-4 text-xs"
          onSubmit={(e) => {
            e.preventDefault();
            if (!fileToUpload) {
              toast.warning("Por favor, sube una imagen antes de enviar.");
              return;
            }
            setNewAccessModal(false)
            uploadNewAccess();
          }} 
        >

          <div className="title">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Título
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaCode />
              </span>
              <input
                type="text"
                placeholder="Flaticon"
                value={accessFormValues.title}
                onChange={(e) =>
                  setAccessFormValues((prev) => ({
                    ...prev,
                    title: e.target.value,
                  }))
                }                  
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="accessLink">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Acceso
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaLink />
              </span>
              <input
                type="text"
                placeholder="https://www.flaticon.com"
                value={accessFormValues.accessLink}
                onChange={(e) =>
                  setAccessFormValues((prev) => ({
                    ...prev,
                    accessLink: e.target.value,
                  }))
                }  
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="userOrEmail">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Usuario o Email
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaUser />
              </span>
              <input
                type="text"
                placeholder="administracion@monstruocreativo.com"
                value={accessFormValues.userOrEmail}
                onChange={(e) =>
                  setAccessFormValues((prev) => ({
                    ...prev,
                    userOrEmail: e.target.value,
                  }))
                } 
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="password">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Contraseña
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaLock />
              </span>
              <input
                type="text"
                placeholder="C0ntr4s3ñ4S3gur4123"
                value={accessFormValues.password}
                onChange={(e) =>
                  setAccessFormValues((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                } 
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="image">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Imagen
            </label>
            <div className="flex">
              <label
                htmlFor="dropzone-file"
                onDrop={handlePrepareFile}
                className="flex flex-col items-center justify-center w-full h-48 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600 transition-all duration-100"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  {fileToUpload === null ? (
                    <>
                      <FaCloudArrowUp className="text-2xl text-gray-500 mb-2" />
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold text-xs">
                          Sube un archivo
                        </span>
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        PNG, JPG - Maximo 5MB
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-col hover:cursor-pointer gap-2 items-center justify-center h-16 w-12 text-white">
                        <img src={URL.createObjectURL(fileToUpload)} alt={accessFormValues.title} />
                      </div>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold text-xs">
                          1 archivo listo para subir
                        </span>
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        PNG, JPG - Maximo 5MB
                      </p>
                    </>
                  )}
                </div>
                <input
                  onChange={handlePrepareFile}
                  id="dropzone-file"
                  accept="image/*"
                  type="file"
                  className="hidden"
                />
              </label>
            </div>
          </div>

          <div className="workers">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Trabajadores que tendrán acceso
            </label>
            <div className="grid grid-cols-3 gap-2">
              {workers.map((worker) => (
                <div key={worker.id} className="bg-gray-100 justify-between px-4 py-1 rounded-full flex flex-row gap-2 items-center">
                  <div className="flex flex-col max-w-[80%]">
                    <span className="text-xs truncate font-bold">{worker.name}</span>
                    <span className="text-[8px] lowercase truncate overflow-hidden whitespace-nowrap text-ellipsis">{worker.puesto}</span>
                  </div>
                  <input
                    type="checkbox"
                    className="rounded-md border-gray-400 hover:cursor-pointer"
                    checked={accessFormValues.workers.includes(worker.id)}
                    onChange={() => handleCheckboxChange(worker.id)}
                  />
                </div>
              ))}
            </div>
          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            type="submit"
          >
            Crear acceso
          </Button>

        </form>
      </Modal>

      <Modal // Modal para editar accesos
        onClose={() => {
          setEditModal(false)
          setFileToUpload(null)
          setAccessToEditId("")
          setAccessEditFormValues({
            title: "",
            image: "",
            accessLink: "",
            userOrEmail: "",
            password: "",
            workers: [],
          })
        }}
        activeModal={editModal}
        title="Editar acceso"
        centered
      >
        <form 
          className="flex flex-col gap-4 text-xs"
          onSubmit={(e) => {
            e.preventDefault();
            setEditModal(false)
            handleSaveEditedAccess();
          }} 
        >

          <div className="title">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Título
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaCode />
              </span>
              <input
                type="text"
                placeholder="Flaticon"
                value={editAccessFormValues.title}
                onChange={(e) =>
                  setAccessEditFormValues((prev) => ({
                    ...prev,
                    title: e.target.value,
                  }))
                }                  
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="accessLink">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Acceso
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaLink />
              </span>
              <input
                type="text"
                placeholder="https://www.flaticon.com"
                value={editAccessFormValues.accessLink}
                onChange={(e) =>
                  setAccessEditFormValues((prev) => ({
                    ...prev,
                    accessLink: e.target.value,
                  }))
                }  
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="userOrEmail">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Usuario o Email
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaUser />
              </span>
              <input
                type="text"
                placeholder="administracion@monstruocreativo.com"
                value={editAccessFormValues.userOrEmail}
                onChange={(e) =>
                  setAccessEditFormValues((prev) => ({
                    ...prev,
                    userOrEmail: e.target.value,
                  }))
                } 
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="password">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Contraseña
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                <FaLock />
              </span>
              <input
                type="text"
                placeholder="C0ntr4s3ñ4S3gur4123"
                value={editAccessFormValues.password}
                onChange={(e) =>
                  setAccessEditFormValues((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                } 
                className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                required
              />
            </div>
          </div>

          <div className="image">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Imagen
            </label>
            <div className="flex">
              <label
                htmlFor="dropzone-file"
                onDrop={handlePrepareFile}
                className="flex flex-col items-center justify-center w-full h-48 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600 transition-all duration-100"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  {fileToUpload !== null ? (
                    <>
                      <div className="flex flex-col hover:cursor-pointer gap-2 items-center justify-center h-16 w-12 text-white">
                        <img src={URL.createObjectURL(fileToUpload)} alt={editAccessFormValues.title} />
                      </div>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold text-xs">
                          1 archivo listo para subir
                        </span>
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        PNG, JPG - Maximo 5MB
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-col hover:cursor-pointer gap-2 items-center justify-center h-16 w-12 text-white">
                        <img src={imageToEdit} alt={editAccessFormValues.title} />
                      </div>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold text-xs">
                          Ya hay una imagen existente, haz lick para reemplazar
                        </span>
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        PNG, JPG - Maximo 5MB
                      </p>
                    </>
                  )}
                </div>
                <input
                  onChange={handlePrepareFile}
                  id="dropzone-file"
                  accept="image/*"
                  type="file"
                  className="hidden"
                />
              </label>
            </div>
          </div>

          <div className="workers">
            <label className="block text-gray-700 mb-2" htmlFor="createdBy">
              Trabajadores que tendrán acceso
            </label>
            <div className="grid grid-cols-3 gap-2">
              {workers.map((worker) => (
                <div key={worker.id} className="bg-gray-100 justify-between px-4 py-1 rounded-full flex flex-row gap-2 items-center">
                  <div className="flex flex-col max-w-[80%]">
                    <span className="text-xs truncate font-bold">{worker.name}</span>
                    <span className="text-[8px] lowercase truncate overflow-hidden whitespace-nowrap text-ellipsis">{worker.puesto}</span>
                  </div>
                  <input
                    type="checkbox"
                    className="rounded-md border-gray-400 hover:cursor-pointer"
                    checked={editAccessFormValues.workers.includes(worker.id)}
                    onChange={() => handleEditCheckboxChange(worker.id)}
                  />
                </div>
              ))}
            </div>
          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            type="submit"
          >
            Actualizar acceso
          </Button>

        </form>
      </Modal>

      {profileRedux &&
        profileRedux?.verificacionHabilitada &&
        !profileRedux?.verificado && (
          <VerificationTrabajadorDialog
            open={openVerificationModal}
            profile={profileRedux}
            setOpen={setOpenVerificationModal}
          />
        )
      }   

      <Box
        sx={{
          minHeight: 1,
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
        }}
      >
        
        {!lgUp && (
          <div className="p-4">
            <IconButton
              onClick={() => setOpenNav(true)}
              sx={{
                backgroundColor: 'orange.500',       
                backgroundOpacity: 0.8,              
                borderRadius: '0.375rem',            
                padding: '12px',                     
                cursor: 'pointer',                   
                transition: 'all 0.2s ease-in-out', 
                '&:hover': {
                  backgroundOpacity: 0.1,            
                },
                mr: 1, // Preserva el margen derecho
              }}
            >
              <TbLayoutSidebarLeftCollapse className="text-orange-400"/>
            </IconButton>
          </div>
        )}


        <Nav 
          handleLogout={handleLogout} 
          user={user} 
          openNav={openNav} 
          onCloseNav={() => setOpenNav(false)} 
        />

        <Main>
          <HomeRoutes />
        </Main>
      </Box>

      <div className="absolute z-50">
        
        {/* Backdrop operativa */}
        {buttonsDrawer && (
          <div 
            className="fixed inset-0 z-30" 
            onClick={() => {
              setButtonsDrawer(false)
              closeOperativeTabs()
            }}
          />
        )}

        {/* Panel operativa */}
        <div
          className={`fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3 transition-all duration-300 ease-in-out ${
            buttonsDrawer ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'
          }`}
          style={{ maxHeight: 'calc(100vh - 120px)' }}
        >
          <div className="w-96 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
            {/* Header del panel */}
            <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-gray-800 to-gray-700">
              <div className="flex items-center gap-2">
                <FaCode className="text-white text-sm" />
                <span className="text-sm font-bold text-white">Área Operativa</span>
              </div>
              <button 
                onClick={() => {
                  setButtonsDrawer(false)
                  closeOperativeTabs()
                }}
                className="text-white/80 hover:text-white hover:bg-white/20 rounded-full p-1 transition-all duration-150"
              >
                <FaTimes className="text-xs" />
              </button>
            </div>

            {/* Contenido */}
            <div className="flex flex-col gap-1.5 p-3 max-h-[60vh] overflow-y-auto">

              {/* Google Meets */}
              <div className="flex flex-col">
                <button
                  className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                    isClicked 
                      ? 'bg-orange-500 text-white shadow-lg shadow-orange-200' 
                      : 'bg-white text-gray-700 hover:bg-orange-50 border border-gray-200 hover:border-orange-300'
                  }`}
                  onClick={handleClick}
                >
                  <div className="flex items-center gap-2">
                    <div className={`w-2.5 h-2.5 rounded-full ${isClicked ? 'bg-white' : 'bg-orange-500'}`} />
                    <span>Google Meets</span>
                  </div>
                  <SiGooglemeet className={`text-sm shrink-0 ${isClicked ? 'text-white' : 'text-orange-400'}`} />
                </button>
                {isClicked && (
                  <div className="mt-1 ml-2 flex flex-col gap-0.5 py-1 max-h-[40vh] overflow-y-auto">
                    {filteredLinks.map((category) => (
                      <div key={category.id} className="flex flex-col">
                        <button
                          className={`flex items-center justify-between w-full px-3 py-2.5 text-xs font-semibold rounded-lg transition-all duration-150 ${
                            selectedCategory === category.id 
                              ? 'text-orange-600 bg-orange-50' 
                              : 'text-gray-700 hover:bg-gray-100'
                          }`}
                          onClick={() => handleCategoryClick(category.id)}
                        >
                          <div className="flex items-center gap-2">
                            <SiGooglemeet className="text-orange-400 text-xs" />
                            <span className="truncate">{category.name}</span>
                          </div>
                          {selectedCategory === category.id 
                            ? <FaChevronDown className="text-[10px] text-gray-400 shrink-0 ml-2" /> 
                            : <FaChevronRight className="text-[10px] text-gray-400 shrink-0 ml-2" />
                          }
                        </button>
                        {selectedCategory === category.id && (
                          <div className="flex flex-col ml-3 pl-3 border-l-2 border-orange-200 gap-0.5 py-1">
                            {category.elemento.map((subcategory) => (
                              <a
                                key={subcategory.id}
                                href={subcategory.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 px-3 py-2 text-xs text-gray-600 hover:text-orange-600 hover:bg-orange-50 rounded-md transition-all duration-150"
                              >
                                <FaExternalLinkAlt className="text-[9px] shrink-0" />
                                <span className="truncate">{subcategory.name}</span>
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Recursos */}
              <div className="flex flex-col">
                <button
                  className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                    showResources 
                      ? 'bg-green-600 text-white shadow-lg shadow-green-200' 
                      : 'bg-white text-gray-700 hover:bg-green-50 border border-gray-200 hover:border-green-300'
                  }`}
                  onClick={() => setShowResources(!showResources)}
                >
                  <div className="flex items-center gap-2">
                    <div className={`w-2.5 h-2.5 rounded-full ${showResources ? 'bg-white' : 'bg-green-500'}`} />
                    <span>Recursos</span>
                  </div>
                  <FaBook className={`text-sm shrink-0 ${showResources ? 'text-white' : 'text-green-400'}`} />
                </button>
                {showResources && resources && resources.length > 0 && (
                  <div className="mt-1 ml-2 flex flex-col gap-0.5 py-1">
                    {resources.map((r) => (
                      <a
                        key={r.id}
                        href={r.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-3 py-2.5 text-xs text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-all duration-150"
                      >
                        <FaExternalLinkAlt className="text-[9px] shrink-0" />
                        <span className="truncate">{r.title}</span>
                      </a>
                    ))}
                  </div>
                )}
              </div>

              {/* Accesos */}
              <div className="flex flex-col">
                <button
                  className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                    showList 
                      ? 'bg-blue-600 text-white shadow-lg shadow-blue-200' 
                      : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-200 hover:border-blue-300'
                  }`}
                  onClick={() => setShowList(!showList)}
                >
                  <div className="flex items-center gap-2">
                    <div className={`w-2.5 h-2.5 rounded-full ${showList ? 'bg-white' : 'bg-blue-500'}`} />
                    <span>Accesos</span>
                  </div>
                  <FaKey className={`text-sm shrink-0 ${showList ? 'text-white' : 'text-blue-400'}`} />
                </button>
                {showList && (
                  <div className="mt-1 ml-2 flex flex-col gap-0.5 py-1">
                    {user.area.toUpperCase() === "ADMINISTRACION" && (
                      <button 
                        onClick={() => setNewAccessModal(true)}
                        className="flex items-center gap-2 px-3 py-2.5 text-xs font-semibold text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-150"
                      >
                        <FaPlus className="text-[9px] shrink-0" />
                        <span>Crear nuevo acceso</span>
                      </button>
                    )}
                    {accounts && accounts.length > 0 ? (
                      accounts.map((account) => (
                        <div key={account.id} className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 rounded-lg transition-all duration-150">
                          <Tooltip
                            interactive
                            content={
                              <div className="flex flex-col gap-1 p-2">
                                <div className="flex flex-row gap-2">
                                  <span className="text-xs">Acceso: </span>
                                  <a
                                    href={account.accessLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline text-xs truncate font-bold text-blue-500"
                                  >
                                    {account.accessLink}
                                  </a>
                                </div>
                                <div className="flex flex-row gap-2">
                                  <span className="text-xs">Cuenta: </span>
                                  <span
                                    className="hover:underline text-xs flex flex-row gap-2 items-center justify-center hover:cursor-pointer"
                                    onClick={() => handleCopy(account.userOrEmail)}
                                  >
                                    {account.userOrEmail}<FaCopy />
                                  </span>
                                </div>
                                <div className="flex flex-row gap-2">
                                  <span className="text-xs">Contraseña: </span>
                                  <span
                                    className="hover:underline text-xs flex flex-row gap-2 items-center justify-center hover:cursor-pointer"
                                    onClick={() => handleCopy(account.password)}
                                  >
                                    {account.password}<FaCopy />
                                  </span>
                                </div>
                              </div>
                            }
                          >
                            <div className="flex items-center gap-2 cursor-pointer">
                              <img src={account.image.url} alt={account.title} className="w-8 h-8 rounded-md object-cover" />
                              <span className="text-xs font-semibold text-gray-700 truncate">{account.title}</span>
                            </div>
                          </Tooltip>
                          {user.area.toUpperCase() === "ADMINISTRACION" && (
                            <div className="flex items-center gap-1 shrink-0 ml-2">
                              <button
                                onClick={() => {
                                  setEditModal(true)
                                  setImageToEdit(account.image.url)
                                  setAccessToEditId(account.id)
                                  setAccessEditFormValues({
                                    title: account.title,
                                    image: account.image.id,
                                    accessLink: account.accessLink,
                                    userOrEmail: account.userOrEmail,
                                    password: account.password,
                                    workers: account.workers.map((worker) => worker.id),
                                  })
                                }}
                                className="p-1.5 hover:bg-green-50 rounded-md transition-all"
                              >
                                <FaEdit className="text-green-500 text-xs" />
                              </button>
                              <button
                                onClick={() => handleDeleteAccess(account.id)}
                                className="p-1.5 hover:bg-red-50 rounded-md transition-all"
                              >
                                <FaTrash className="text-red-500 text-xs" />
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <span className="text-xs text-gray-500 px-3 py-2">No tienes accesos asignados 😞</span>
                    )}
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>

        {/* Botón flotante operativa */}
        <button
          onClick={handleButtonDrawer}
          className={`fixed bottom-6 right-6 z-50 w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 ${
            buttonsDrawer || buttonsComercial
              ? 'bg-gray-800 hover:bg-gray-700 opacity-0 pointer-events-none' 
              : 'bg-gray-800 hover:bg-gray-700 hover:shadow-xl hover:scale-105'
          } text-white`}
        >
          <FaCode className="text-lg" />
        </button>

        {/* Area comercial */}
        {(user.area.toUpperCase() === "ADMINISTRACION" || user.area.toUpperCase() === "COMERCIAL" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
          <>
            {/* Backdrop para cerrar al hacer click afuera */}
            {buttonsComercial && (
              <div 
                className="fixed inset-0 z-30" 
                onClick={closeCommercialPanel}
              />
            )}

            {/* Panel comercial */}
            <div
              className={`fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3 transition-all duration-300 ease-in-out ${
                buttonsComercial ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'
              }`}
              style={{ maxHeight: 'calc(100vh - 120px)' }}
            >
              {commercialLinks && commercialLinks.length > 0 && (
                <div className="w-96 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
                  {/* Header del panel */}
                  <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-green-600 to-green-500">
                    <div className="flex items-center gap-2">
                      <FaBriefcase className="text-white text-sm" />
                      <span className="text-sm font-bold text-white">Área Comercial asdasdasd</span>
                    </div>
                    <button 
                      onClick={closeCommercialPanel}
                      className="text-white/80 hover:text-white hover:bg-white/20 rounded-full p-1 transition-all duration-150"
                    >
                      <FaTimes className="text-xs" />
                    </button>
                  </div>

                  {/* Lista de botones */}
                  <div className="flex flex-col gap-1.5 p-3 max-h-[60vh] overflow-y-auto">
                    {commercialLinks.map((link, i) => (
                      <LateralMenuButton 
                        key={i}
                        title={link.title}
                        item={link}
                        isExpanded={expandedCommercialIdx === i}
                        onToggle={() => setExpandedCommercialIdx(expandedCommercialIdx === i ? null : i)}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Botón flotante para abrir/cerrar */}
            <button
              onClick={handleButtonComercial}
              className={`fixed bottom-20 right-6 z-50 w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 ${
                buttonsComercial || buttonsDrawer
                  ? 'bg-gray-800 hover:bg-gray-700 translate-y-0 opacity-0 pointer-events-none' 
                  : 'bg-green-600 hover:bg-green-700 hover:shadow-xl hover:scale-105'
              } text-white`}
            >
              <FaBriefcase className="text-lg" />
            </button>
          </>
        )}

        {/* Teléfono Twilio */}
        <TwilioPhone hideButton={buttonsDrawer || buttonsComercial} />

      </div>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};